import { Button } from "@/components/ui/button";

/**
 * Shown by the top-level Sentry `ErrorBoundary` when rendering crashes.
 *
 * Deliberately router- and query-free: it renders outside the providers that
 * may have caused the crash, so it uses a full page reload to recover.
 */
export function ErrorFallback() {
  return (
    <div className="bg-background flex min-h-screen flex-col items-center justify-center px-4">
      <p className="text-muted t-eyebrow">Error</p>
      <h1 className="t-title text-foreground mt-3">Something went wrong</h1>
      <p className="text-muted mt-4 max-w-sm text-center text-lg">
        The page hit an unexpected error. Reloading usually fixes it.
      </p>
      <Button
        type="button"
        onClick={() => window.location.reload()}
        className="bg-accent text-accent-foreground hover:bg-accent-hover mt-8 h-12 rounded-sm px-6 font-semibold"
      >
        Reload the page
      </Button>
    </div>
  );
}
